module.exports = __webpack_public_path__ + "img/404_road.56791441.svg";